export const EXPERIENCE_INFERENCE_GENERATE = '/asset/{0}/device/actions/device-analytics/TipsTricks';
export const EXPERIENCE_INFERENCE_GET = '/asset/{0}/device/inference/TipsTricks';
